import { render, staticRenderFns } from "./PencilSimple.vue?vue&type=template&id=489168cf"
import script from "./PencilSimple.vue?vue&type=script&lang=js"
export * from "./PencilSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports